import React from "react";

export default function About() {
    return (
        <div className="about">
        <h3 className="about--title">About</h3>
        <p className="about--description">
        I'm a passionate IT professional with a Bachelor's degree in Information Technology and a love for all things computer-related. Deeply immersed in the world of programming, web development, databases, and cloud computing. Alongside my tech skills, I've honed my customer service abilities in the vibrant casino environment as a blackjack dealer, adding a unique twist to my profile.
        </p>
        </div>
    );
}
